import { useRouter } from "next/router"
import React from "react"
import CustomButton from "../../../../../ui/atoms/Button"
import Typography from "../../../../../ui/atoms/Typography"
import { useLabels } from "../../../../contents/hooks"

const EmptyBasket = () => {
  const router = useRouter()
  const { getLabel } = useLabels()
  return (
    <>
      <Typography variant="body1">
        {getLabel("basket", "empty-basket")}
      </Typography>
      <CustomButton
        className="my-6"
        size="small"
        fullWidth
        onClick={() => router.push("/")}
      >
        {getLabel("basket", "go-to-shopping")}
      </CustomButton>
    </>
  )
}

export default EmptyBasket
